import { pageBreadcrumbStyles } from "@insite/content-library/Components/PageBreadcrumbs";
import { css } from "styled-components";

pageBreadcrumbStyles.breadcrumbs = {
    mergeCss: true,
    css: css`
        @media print {
            display: none !important;
        }
    `,
}